<script setup lang="ts">
    import { API_CONFIG, BACKEND_URL } from '@/services/apiConfig';
    import { onMounted, ref } from 'vue';
    import { useRoute } from 'vue-router';
    import debounce from "lodash.debounce";

    const route = useRoute();
    const itemsList = ref([] as any[]);
    const selectedItem = ref(null as any);
    const query = ref("");

    onMounted(() => {
        const data: any = route.meta.startup_infos;
        itemsList.value = data;
    });

    function doSelectItem(item: any) {
        if (selectedItem.value?.id == item.id) {
            selectedItem.value = null;
        } else {
            selectedItem.value = item;
        }
    }

    const search = debounce(async () => {
        const params = new URLSearchParams({
            q: query.value
        });
        const response = await fetch(`${API_CONFIG.baseURL}/faq?${params.toString()}`, {
            method: 'GET',
            headers: API_CONFIG.headers
        });
        const responseData = await response.json();
        itemsList.value = responseData;
    }, 300);
</script>

<template>
    <div class="page-space"></div>
    <section class="container-lil">

        <!--Search in view Component-->
        <div class="search-view-input-set">
            <input type="text" class="search-view-input" placeholder="Faire une recherche..." v-model="query" @input="search" />
            <button class="btn-ultra white tips"><!-- loading sm tips color2 light white white2 success info warning danger-->
                <div class="btn-show">
                    <img src="/public/icons/icon-go.svg" class="btn-icon" alt="" />
                </div>
                <div class="btn-loading">
                    <div class="loader-dots"></div>
                </div>
            </button>
        </div>
        <!--End Search in view Component-->
        <div class="h-30">
            <template v-for="(item) in itemsList" :key="'item_' + item.id">
                <div @click="doSelectItem(item)" class="flex items-center gap-4 p-4 border border-grey-200 rounded-lg cursor-pointer hover:bg-grey-50 transition-all">
                    <div>
                        <img :src="item.fichier_photo_url" style="height: 65px" />
                    </div>
                    <div class="flex-1">
                        <h3 class="text-xl font-semibold text-base">{{ item.libelle }}</h3>
                        <p class="text-grey-600">{{ item.categorie_aide?.libelle }}</p>
                        <p class="text-primary-color font-medium mt-1">FAQ</p>
                    </div>
                    <div class="flex-shrink-0">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-grey-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                        </svg>
                    </div>
                </div>
                <div v-show="selectedItem?.id == item.id">
                    {{ item.contenu_aide }}
                </div>
            </template>
        </div>
        <!---->

        <div class="clear-both h-40"></div>
    </section>
</template>
